import { GetOrdersParams } from './api';

export const keys = {
  getOrders: (params: GetOrdersParams) => [
    'windows',
    'agent',
    'orders',
    ...Object.values(params),
  ],
  refreshOrder: (orderId: string) => [
    'mutation',
    'windows',
    'agent',
    'orders',
    orderId,
    'refresh',
  ],
  sendQuote: (orderId: string) => [
    'mutation',
    'windows',
    'agent',
    'orders',
    orderId,
    'send-quote',
  ],
  cancelOrder: (orderId: string) => [
    'mutation',
    'windows',
    'agent',
    'orders',
    orderId,
    'cancel',
  ],
};
